(function () {
  'use strict';

  var selector = document.getElementById('anx-locale-select');
  if (!selector || !selector.form) return;

  var preferenceKey = 'anx-language-preference';
  var storage;
  try {
    storage = window.localStorage;
    storage.getItem(preferenceKey);
  } catch (_) {
    return;
  }

  selector.addEventListener('change', function () {
    try { storage.setItem(preferenceKey, 'manual:' + selector.value); } catch (_) {}
  }, true);

  if (window.Shopify && window.Shopify.designMode) return;
  if (/[?&](?:preview_theme_id|pb)=/.test(window.location.search)) return;
  if (/bot|crawler|spider|slurp|bingpreview|google-inspectiontool|lighthouse/i.test(navigator.userAgent)) return;
  if ((storage.getItem(preferenceKey) || '').indexOf('manual:') === 0) return;

  var current = document.documentElement.lang.toLowerCase().split('-')[0];
  var path = window.location.pathname.toLowerCase();
  if (/^\/(?:ar|en)(?:\/|$)/.test(path)) return;

  var primary = (navigator.languages && navigator.languages[0]) || navigator.language || '';
  var preferred = primary.toLowerCase().split('-')[0];
  if (!preferred || preferred === current) return;
  if (!Array.prototype.some.call(selector.options, function (option) { return option.value.toLowerCase() === preferred; })) return;

  try {
    var onceKey = 'anx-language-auto:' + window.location.pathname + window.location.search;
    if (window.sessionStorage.getItem(onceKey) === preferred) return;
    window.sessionStorage.setItem(onceKey, preferred);
  } catch (_) {
    return;
  }

  selector.value = preferred;
  selector.form.submit();
})();
